// Notifications are currently local-only. The backend endpoint is not used yet,
// so this module intentionally avoids making any network requests.

// Maps backend module keys to display label + frontend route
const MODULE_MAP = {
  'population':               { label: 'Livestock Population',      route: '/livestock-population' },
  'livestock':                { label: 'Livestock Population',      route: '/livestock-population' },
  'livestock-population':     { label: 'Livestock Population',      route: '/livestock-population' },
  'markets':                  { label: 'Markets & Trade',           route: '/markets-trade' },
  'markets-trade':            { label: 'Markets & Trade',           route: '/markets-trade' },
  'market':                   { label: 'Markets & Trade',           route: '/markets-trade' },
  'infrastructure':           { label: 'Infrastructure Registry',   route: '/infrastructure' },
  'workforce':                { label: 'Workforce & Institutional',  route: '/workforce-institutional' },
  'workforce-institutional':  { label: 'Workforce & Institutional',  route: '/workforce-institutional' },
  'planning':                 { label: 'Planning & Reporting',      route: '/planning-reporting' },
  'planning-reporting':       { label: 'Planning & Reporting',      route: '/planning-reporting' },
  'conflicts':                { label: 'Conflict & Dispute',        route: '/conflicts-dispute' },
  'conflicts-dispute':        { label: 'Conflict & Dispute',        route: '/conflicts-dispute' },
  'animal-identification':    { label: 'Animal Identification',     route: '/animal-identification' },
  'animal-health':            { label: 'Animal Health',             route: '/animal-health' },
  'admin':                    { label: 'Administration',            route: '/admin' },
  'system':                   { label: 'System',                   route: '/dashboard' },
};

export const TYPE_TITLE_MAP = {
  workflow_rejected:  'Record Rejected',
  workflow_approved:  'Record Approved',
  workflow_submitted: 'Record Submitted for Review',
  workflow_validated: 'Record Validated',
  rejected:           'Record Rejected',
  approved:           'Record Approved',
  submitted:          'Record Submitted for Review',
  validated:          'Record Validated',
  system:             'System Notification',
};

export function resolveModule(key) {
  const k = String(key ?? 'system').toLowerCase().replace(/[_\s]+/g, '-').trim();
  return MODULE_MAP[k] ?? { label: key ?? 'System', route: '/dashboard' };
}

export const notificationsApi = {
  async list() {
    return [];
  },

  async markRead(uuid) {
    return;
  },

  async markAllRead() {
    return;
  },
};
